import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { SimDividerComponent } from '@simOn/ui/sim-divider';
import { SimUserInfoComponent } from '@simOn/user/info/ui';
import { TLastVisitedUser } from '@simOn/user/last-visited/models';
import { LastActivePipe } from './sim-last-active.pipe';

@Component({
  selector: 'user-last-visited',
  template: `
    <div data-cy="active-users-container">
      <h4 i18n="@@ACTIVE_USERS" class="title">Active users</h4>
      <sim-divider />
      @for (user of activeUsers(); track user.id) {
        <user-info [userEmail]="user.email" [userName]="user.userName" [userId]="user.id" />
        <sim-divider />
      }
    </div>
    <div data-cy="last-visitors-container">
      <h5 i18n="@@LAST_VISITORS" class="title">Last visitors</h5>
      <sim-divider />
      @for (user of lastVisitors(); track user.id) {
        <div class="last-visitors" data-cy="last-visitors">
          <span class="last-visitors__email">{{ user.email }}</span>
          <span class="last-visitors__date">{{ user.lastActivity | lastActive }}</span>
        </div>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./sim-active-users.component.scss'],
  imports: [SimDividerComponent, SimUserInfoComponent, LastActivePipe]
})
export class SimActiveUsersComponent {
  private readonly sortedUsers = computed(() =>
    [...this.apartmentUsers()].sort((a, b) => {
      if (a.lastActivity === null) return 1;
      if (b.lastActivity === null) return -1;

      return Date.parse(b.lastActivity) - Date.parse(a.lastActivity);
    })
  );

  protected readonly activeUsers = computed(() => this.sortedUsers().filter((user) => user.isActive));
  protected readonly lastVisitors = computed(() => this.sortedUsers().filter((user) => !user.isActive));

  readonly apartmentUsers = input.required<readonly TLastVisitedUser[]>();
}
